import script from "./LiveBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveBanner.vue?vue&type=script&setup=true&lang=ts"

import "./LiveBanner.vue?vue&type=style&index=0&id=5516e54b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5516e54b"]])

export default __exports__